"use strict";

exports.__esModule = true;
exports.selectVehicle = exports.selectModel = exports.getVehicleData = exports.getAllSubSpecificationGroups = exports.getAllSpecificationGroups = exports.getAllModels = exports.deselectVehicle = exports.deselectModel = exports.clearVehiclesData = void 0;

var _actionTypes = require("./action-types");

var selectVehicle = function selectVehicle(vehicle) {
  return {
    type: _actionTypes.SELECT_VEHICLE,
    vehicle: vehicle
  };
};

exports.selectVehicle = selectVehicle;

var deselectVehicle = function deselectVehicle() {
  return {
    type: _actionTypes.DESELECT_VEHICLE
  };
};

exports.deselectVehicle = deselectVehicle;

var getAllModels = function getAllModels(models) {
  return {
    type: _actionTypes.GET_ALL_MODELS,
    models: models
  };
};

exports.getAllModels = getAllModels;

var getAllSpecificationGroups = function getAllSpecificationGroups(specificationGroups) {
  return {
    type: _actionTypes.GET_ALL_SPECIFICATION_GROUPS,
    specificationGroups: specificationGroups
  };
};

exports.getAllSpecificationGroups = getAllSpecificationGroups;

var getAllSubSpecificationGroups = function getAllSubSpecificationGroups(subSpecificationGroups) {
  return {
    type: _actionTypes.GET_ALL_SUB_SPECIFICATION_GROUPS,
    subSpecificationGroups: subSpecificationGroups
  };
};

exports.getAllSubSpecificationGroups = getAllSubSpecificationGroups;

var selectModel = function selectModel(selectedModelCode, order) {
  return {
    type: _actionTypes.SELECT_MODEL,
    selectedModelCode: selectedModelCode,
    order: order
  };
};

exports.selectModel = selectModel;

var deselectModel = function deselectModel(selectedModelCode, order) {
  return {
    type: _actionTypes.DESELECT_MODEL,
    selectedModelCode: selectedModelCode,
    order: order
  };
};

exports.deselectModel = deselectModel;

var getVehicleData = function getVehicleData(models, specificationGroups, subSpecificationGroups) {
  return {
    type: _actionTypes.GET_VEHICLE_DATA,
    data: {
      models: models,
      specificationGroups: specificationGroups,
      subSpecificationGroups: subSpecificationGroups
    }
  };
};

exports.getVehicleData = getVehicleData;

var clearVehiclesData = function clearVehiclesData() {
  return {
    type: _actionTypes.CLEAR_VEHICLES_DATA
  };
};

exports.clearVehiclesData = clearVehiclesData;